import { Capacitor } from '@capacitor/core';

export const PAYPAL_PENDING_KEY = 'parachpay_pp_pending';

// Android WebViews (Capacitor app) can't open PayPal's checkout popup.
export const isInAppWebView = () => {
  try {
    if (Capacitor.isNativePlatform()) return true;
  } catch (e) {
    // ignore
  }
  return /; wv\)/.test(navigator.userAgent || '');
};

export const readPendingPayPal = () => {
  try {
    return JSON.parse(localStorage.getItem(PAYPAL_PENDING_KEY) || 'null');
  } catch (e) {
    return null;
  }
};

export const clearPendingPayPal = () => {
  try {
    localStorage.removeItem(PAYPAL_PENDING_KEY);
  } catch (e) {
    // ignore
  }
};
